export enum gateway_recommendation_type {
  region = "region",
  checkoutUrl = "checkoutUrl",
  amount = "amount",
  currency = "currency",
}
